import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import { formatPhoneLink } from '../../../../utils/formatters';

export interface ICallPhoneButtonProps {
  onClick?(): void;
  phone: string;
}

export const CallPhoneButton: React.VFC<ICallPhoneButtonProps> = ({ phone, onClick }) => {
  return (
    <LinkButton
      href={formatPhoneLink(phone)}
      onClick={onClick}
      size="M"
      type="button"
      data-testid="CallPhoneButton"
      fullWidth
    >
      Позвонить
    </LinkButton>
  );
};
